import { TAQLAudit } from '@monorepo/types';
import { ModifiersZTableModel } from '../../../table.modifier';
import { TTableCellType, TTableInfo, TTextCell } from '../../../table.type';
import * as moment from 'moment';

const createHeaderRow = (): TTableInfo['header']['cells'] => {
  return [
    {
      type: 'TEXT_CELL',
      text: 'DATE & TIME',
      widthInPx: 4,
    },
    {
      type: 'TEXT_CELL',
      text: 'AUDIT ID',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'LINE',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'BUYER',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'STYLE',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'PO',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'COLOR',
      widthInPx: 10,
    },
    {
      type: 'TEXT_CELL',
      text: 'ACTION TAKEN',
      widthInPx: 10,
    },
  ];
};

const getRows = (rowItem: TAQLAudit) => {
  const rows = [
    {
      type: 'TEXT_CELL',
      text: moment(new Date(Number(rowItem.metaData.datetime))).format('MMM D, HH:mm'),
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.metaData.auditDisplayName,
      hrefActionCB: 'AUDIT_ID_CLICKED',
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.metaData.lineAndHskDetails.dnm,
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.auditDetails.sampleBctxDetails.buyer,
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.auditDetails.sampleBctxDetails.style,
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.auditDetails.sampleBctxDetails.po,
    },
    {
      type: 'TEXT_CELL',
      text: rowItem.auditDetails.sampleBctxDetails.color,
    },
    {
      type: 'TEXT_CELL',
      text:
        rowItem.metaData.action_taken === 'undo_audit'
          ? 'Undo Audit'
          : rowItem.statusInfo.status === 'pass'
          ? 'Passed Audit'
          : 'Failed Audit',
    },
  ] as TTableCellType[];

  return rows;
};

export const AQL_ACTION_HISTORY_LISTING_TABLE_MODEL = {
  createModel: (rowInfo: TAQLAudit[]) => {
    return ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        headerConfig: createHeaderRow(),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: getRows(item),
        };
      },
    );
  },
};
